import { render, staticRenderFns } from "./GlossaryGroup.vue?vue&type=template&id=62f14eb9"
import script from "./GlossaryGroup.vue?vue&type=script&lang=js"
export * from "./GlossaryGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports